import {Component} from "@angular/core";

@Component({
	selector: "sim-exam-device-panel",
	templateUrl: "./exam-device-panel.component.html",
	styleUrl: "./exam-device-panel.component.scss",
	standalone: true,
})
export class ExamDevicePanelComponent {}
